import { CacheStats, CachedInstructionMapping } from '../instructionsTypes';

class ElectronInstructionsApi {
  private getBridge(): any {
    try {
      return (window as any).electronAPI?.instructions;
    } catch (error) {
      console.warn('Electron instructions bridge lookup failed:', error);
      return undefined;
    }
  }

  async isAvailable(): Promise<boolean> {
    return Boolean(this.getBridge());
  }

  async prefetchInBackground(urls: string[]): Promise<CachedInstructionMapping> {
    const bridge = this.getBridge();
    if (!bridge) {
      console.warn('Electron instructions API not available for prefetch');
      return {};
    }

    try {
      return await bridge.prefetch(urls);
    } catch (error) {
      console.error('Error prefetching instructions in background:', error);
      return {};
    }
  }

  async getLocalPaths(partOrderId: number): Promise<CachedInstructionMapping> {
    const bridge = this.getBridge();
    if (!bridge) {
      console.warn('Electron instructions API not available for getLocalPaths');
      return {};
    }

    try {
      return await bridge.getLocalPaths(partOrderId);
    } catch (error) {
      console.error('Error getting local paths for partOrder', partOrderId, ':', error);
      return {};
    }
  }

  async getCacheStats(): Promise<CacheStats> {
    const bridge = this.getBridge();
    if (!bridge) {
      return { entries: 0, size: 0 };
    }

    try {
      return await bridge.getCacheStats();
    } catch (error) {
      console.error('Error getting cache stats:', error);
      return { entries: 0, size: 0 };
    }
  }

  async downloadAndCache(urls: string[]): Promise<CachedInstructionMapping> {
    const bridge = this.getBridge();
    if (!bridge) {
      console.warn('Electron instructions API not available for download and cache');
      return {};
    }

    try {
      return await bridge.downloadAndCache(urls);
    } catch (error) {
      console.error('Error downloading and caching instructions:', error);
      return {};
    }
  }
}

export const electronInstructionsApi = new ElectronInstructionsApi();
